var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"btn",class:_vm.extraClass || 'primary'},[_c('router-link',{attrs:{"to":_vm.bought ? _vm.productLink: _vm.productRD}},[_c('button',{staticClass:"offerGood"},[_vm._v(" "+_vm._s((_vm.buttonText))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }